import * as React from "react";

interface IProps {
	payload?: {
		value: number;
	};
	y?: number;
	x?: number;
	value?: number;
	height?: number;
	width?: number;
	showAdditionalView?: boolean;
	dataKey?: string;
	data?: any[];
	index?: number;
}

export class PercentLabel extends React.PureComponent<React.Props<{}> & IProps, {}>  {
	render() {
		let { x, y, value, height, width, showAdditionalView, dataKey, data, index } = this.props;
		// only show the label after the second bar, (fund bar)
		if (dataKey === 'Fund' || dataKey === 'Net') {
			 if (dataKey === data[0].DataKeyToUse) {
				if (!showAdditionalView) {	
					return <g transform={`translate(${width + 5}, ${height / 2})`}> <text x={x} y={y} dy={5} fill={"#000000"} fontSize={12} textAnchor="start">{value}%</text> </g>;
				} else {
					return <text></text>;
				}
			}
			else {
				return <text></text>;
		 	}
		}
		if (!showAdditionalView) {
			return <g transform={`translate(${width + 5}, ${height / 2})`}> <text x={x} y={y} dy={5} fill={"#000000"} fontSize={12} textAnchor="start">{value}%</text> </g>;
		} else {
			return <text></text>;
		}
	}
}


// WEBPACK FOOTER //
// ./src/client/components/PageAllocations/PercentLabel.tsx